import classes from "./login-content.module.scss";

import { useCallback } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@honeycomb/ui";
import { LogIn, Mail } from "lucide-react";

export const LoginContentForm = () => {
  const { loginWithRedirect } = useAuth0();

  const handleRedirectSubmit = useCallback(
    (connectionType?: "email") => {
      return () => {
        loginWithRedirect({
          authorizationParams: {
            connection: connectionType,
          },
        });
      };
    },
    [loginWithRedirect]
  );

  return (
    <form className={classes["login-form"]}>
      <div className={classes["login-actions"]}>
        <Button type="primary" data-cy="log-in-email" onClick={handleRedirectSubmit("email")}>
          <Mail /> Send Email Passcode
        </Button>
        <Button type="text" data-cy="log-in-password" onClick={handleRedirectSubmit()}>
          <LogIn /> Password Sign In
        </Button>
      </div>
    </form>
  );
};
